@if (ckeditorReady) {
  <ckeditor #myckeditor class="customEditor" [config]="ckEditorConfig" debounce="100" [(ngModel)]="currentBody" name="currentBody"></ckeditor>
}